// import Vue from 'vue';
import "babel-polyfill";
import { createStore } from "vuex";
import AppModule from "./modules/app";
import ModalModule from "~/js/store/modules/modal";
import EcModule from "~/js/store/modules/ec";
import PinModule from "~/js/store/modules/pin";
import CatalogModule from "~/js/store/modules/catalog";
import ConstantModule from "~/js/store/modules/constant";

const store = createStore({
  modules: {
    app: new AppModule().getModule(),
    modal: new ModalModule().getModule(),
    ec: new EcModule().getModule(),
    pin: new PinModule().getModule(),
    catalog: new CatalogModule().getModule(),
    constant: new ConstantModule().getModule()
  }
});

export default store;
